import { createContext } from "react";
import productStore from "./ProductStore";
import correctorAndProducerStore from "./CorrectorAndProducerStore";

productStore.initialize();
correctorAndProducerStore.initialize();

export const storesContext = createContext({
  productStore,
  correctorAndProducerStore,
});
